__turbopack_context__.v({
  "header": "CodeBlockHeader-module__WoEbma__header",
  "headerContainer": "CodeBlockHeader-module__WoEbma__headerContainer",
  "headerContainerRoundedTop": "CodeBlockHeader-module__WoEbma__headerContainerRoundedTop",
  "label": "CodeBlockHeader-module__WoEbma__label",
  "tabContainer": "CodeBlockHeader-module__WoEbma__tabContainer",
});
